import { get } from 'lodash-es';

export const selectAlertDetails = (state) => get(state, 'alertDetails');
export const selectAlertId = (state) => get(state, 'alertId');
